export enum LocalStorageKey {
  TOKEN = 'token',
  USER = 'user',
  LOGIN_REDIRECT = 'redirectPath',
  ANONYMOUS_TOKEN_WEBINAR = 'anonymousTokenWebinar',
  LEAD = 'lead'
}

export interface User {
  token?: string,
  authorities: string[],
  color?: string,
  email: string,
  id: number,
  locale?: string,
  name: string,
  photo: string,
  tradeName: string
}

export interface GetProfileResponse {
  biography: string,
  email: string,
  hasApprovedAccount: boolean,
  locale: string,
  name: string,
  timeZone: string,
  tradeName?: string,
  website: string,
  urlPhoto?: string,
  thumborUrlPhoto?: string
}
